import React from "react"
import {
    Container,
    Col,
    Row,
    Badge
  } from 'reactstrap';
import SingleCountry from "./SingleCountry"
import Database from "./Database"
import Header from "./Header"

class VotingCalendar extends React.Component{
    constructor(props) {
    super(props);
        this.state = {
          value:'Nigeria',
        }
        this.handleClick = this.handleClick.bind(this);
      }

      handleClick() {
        this.setState({value: this.props.countryname});
        document.getElementById("howvote").scrollIntoView(true);
      }
    
    render(){
        //Filter all the countries that are voting in 2019.
        const CountriesVoting = Database.filter(function(data){
            return(
                data.VotingIn2019 ==="Yes"
            )
        //Sort by earliest date to last date
        }).sort(function (a, b) {
            let nameA = a.NextElectionDate;
            let nameB = b.NextElectionDate;
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            })


        function singlecountry(data){
            return(
                <SingleCountry key={data.ID} electiontype={data.ElectionType} isocode={data.ISO} countryname={data.CountryName} nextelectiondate={data.NextElectionDate} />
            )
        }

        const JanVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-01-31" && data.NextElectionDate > "2019-01-01"
            )
        }).map(singlecountry)
        
        const FebVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-02-31" && data.NextElectionDate > "2019-01-31"
            )
        }).map(singlecountry)

        const MarVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-03-31" && data.NextElectionDate > "2019-02-31"
            )
        }).map(singlecountry) 

        const AprVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-04-31" && data.NextElectionDate > "2019-03-31"
            )
        }).map(singlecountry) 

        const MayVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-05-31" && data.NextElectionDate > "2019-04-31"
            )
        }).map(singlecountry) 

        const JunVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-06-31" && data.NextElectionDate > "2019-05-31"
            )
        }).map(singlecountry) 

        const JulVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-07-31" && data.NextElectionDate > "2019-06-31"
            )
        }).map(singlecountry) 

        const AugVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-08-31" && data.NextElectionDate > "2019-07-31"
            )
        }).map(singlecountry) 

        const SepVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-09-31" && data.NextElectionDate > "2019-08-31"
            )
        }).map(singlecountry) 

        const OctVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-10-31" && data.NextElectionDate > "2019-09-31"
            )
        }).map(singlecountry) 

        const NovVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-11-31" && data.NextElectionDate > "2019-10-31"
            )
        }).map(singlecountry) 

        const DecVoting = CountriesVoting.filter(function(data){
            return(
                data.NextElectionDate <= "2019-12-31" && data.NextElectionDate > "2019-11-31"
            )
        }).map(singlecountry) 

        const Numbervoting = CountriesVoting.length

    return(
        <div>
        <Header/>
        <Container>
            <Row>
                <Col>
                <br/>
                <br/>
                     <h2 className="display-3 text-center">Who's voting this year?</h2>
                     <br/>
                     <p id="electiontype" style={{"marginBottom":"12px"}}>There are three main types of elections.</p>
                     <Badge style={{"marginBottom":"8px","backgroundColor":"#ff9900"}}>Presidential election</Badge>
                     <p>Voters elect the country’s head of state or president. The president holds the highest political position and officially represents the country. </p>
                     <Badge style={{"marginBottom":"8px","backgroundColor":"#996666"}}>Parliamentary election</Badge>
                     <p>The legislative body is elected by the people and, in turn, chooses the head of the government or prime minister. The legislative body implements laws and runs the government on a day-to-day basis.</p>
                     <p>In countries without a prime minister, such as South Africa, Brazil, and the United States, the president is both the head of state and head of government.</p>
                     <Badge style={{"marginBottom":"8px","backgroundColor":"#cc6733"}}>General election</Badge>
                     <p>Voters elect the head of state as well as federal and local representatives.</p>
                     <br/>

                    <h3>The <span style={{fontWeight:900}}>{Numbervoting}</span> countries with elections in 2019:</h3>
                    <br/>
                    {/* <h1>State: {this.state.value}</h1> */}
                </Col>
            </Row>
            <Row>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">January</h3>
                {JanVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">February</h3>
                {FebVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">March</h3>
                {MarVoting}
                </Col>
            </Row>
            <Row>
            <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">April</h3>
                {AprVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">May</h3>
                {MayVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">June</h3>
                {JunVoting}
                </Col>
            </Row>
            <Row>
            <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">July</h3>
                {JulVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">August</h3>
                {AugVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">September</h3>
                {SepVoting}
                </Col>
            </Row>
            <Row>
            <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">October</h3>
                {OctVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">November</h3>
                {NovVoting}
                </Col>
                <Col className="calendarbox" md="4" xs="12">
                <h3 className="calendarmonth">December</h3>
                {DecVoting}
                </Col>
            </Row>
            <Row>
            <Col>
            <br/>
                <p>* Elections expected to be held during that month.</p>
                <p>** India's elections are expected to be held thoughout April and May.</p>
            </Col>
            </Row>
        </Container>
        </div>
        
    )
}
}
export default VotingCalendar